<template>
  <div id="content" class="all_my_projects_space">
    <div class="container">
      <div class="row ">
        <div class="col-12 text-right mt30 mb30">
          <AddSomeThingLink link="/selectYourChallenge" text="Create a new project"/>

        </div>

      </div>
    </div>

    <div class="container">
      <div class="all_my_projects_content">
        <!-- <div class="top_info">
          <div class="row">
            <div class="col-12 col-lg-6 text-center actions_required">
                <span class="number">{{required_tasks}}</span> Action<span v-if="required_tasks > 1">s</span> required
            </div>
            <div class="col-12 col-lg-6 text-center new_deliverable">
                <span class="number">{{innopearl_tasks_ready}}</span> new deliverable<span v-if="innopearl_tasks_ready > 1">s</span>
            </div>
          </div>
        </div> -->


        <div class="projectList">
          <div class="project" v-for="(project, p) in projects" :key="p">
              <router-link :to="'/projet/'+project._id.$oid" class="projectName" v-if="project._id">{{project.name}}</router-link>
               <div class="project_searchfields" v-for="(sf, s) in project.search_field" :key="s">
                 <div class="searchfield_name">
                   <router-link :to="'/projet/'+project._id.$oid+'#'+sf._id.$oid">{{sf.name}}</router-link>
                 </div>
                 <div class="searchfield_action_required">
                     <span class="action_title">{{$t("My actions")}}</span>
                   <div class="">

                     <div class="action_list" :class="(project.business_challenge) ? 'done' : ''" v-if="project.challenges.business_challenge">
                       <div class="name">
                           <router-link :to="'/business_challenge_space/'+project._id.$oid">
                             <span>{{$t('Define business challenge')}}</span>
                                   <img :src="require('@/assets/action_go_to.svg')" alt="">
                                 </router-link>
                       </div>

                     </div>

                     <div class="" v-if="project.challenges.scouting_challenge">
                     <div class="action_list done" v-if="sf.scouting_challenge">
                       <div class="name" v-if="sf.scouting_challenge">
                           <router-link :to="'/scouting_space/'+sf._id.$oid+'/'+project._id.$oid" >
                             <span>{{$t('Define scouting criteria')}}</span>
                                     <img :src="require('@/assets/action_go_to.svg')" alt="">
                           </router-link>
                       </div>
                     </div>

                       </div>

                     <div class="action_list done" v-if="sf.longList.length || sf.candidatesPools.length">
                       <div class="name">
                         <router-link :to="'/my_pools/'+sf._id.$oid+'/'+project._id.$oid">
                           <span>{{$t('Qualify innovators')}}</span>
                                 <img :src="require('@/assets/action_go_to.svg')" alt="">
                               </router-link>
                       </div>
                     </div>

                     <div class="" v-if="project.challenges.assessment_challenge">
                       <div class="action_list done" v-if="sf.assessments.length || (!project.challenges.scouting_challenge && !project.challenges.assessment_challenge)">
                         <div class="name">
                           <router-link :to="'/manage_assessments?project='+project._id.$oid">
                             <span>{{$t("Assess innovators")}}</span>
                                   <img :src="require('@/assets/action_go_to.svg')" alt="">
                                 </router-link>
                         </div>

                       </div>
                       <div class="action_list" :class="(sf.assessmentsResults.length) ? 'done' : ''" v-if="sf.assessmentsResults.length">
                         <div class="name" >
                           <router-link :to="'/potential_partners/'+project._id.$oid+'/'+sf._id.$oid">
                             <span>{{$t('Shortlist potential partners')}}</span>
                                   <img :src="require('@/assets/action_go_to.svg')" alt="">
                                 </router-link>
                         </div>

                       </div>
                     </div>




                   </div>
                 </div>
                   <div class="searchfield_deliverable">
                  <span class="action_title">{{$t("Output")}}</span>
                  <div class=""  v-if="project.challenges.business_challenge">
                    <div class="action_list" :class="(project.business_challenge_sharped) ? 'done' : ''" v-if="project.business_challenge_sharped">
                      <div class="name">
                          <router-link :to="'/business_challenge_space/'+project._id.$oid">
                            <span>{{$t('Targeted business brief')}}</span>
                                  <img :src="require('@/assets/action_go_to.svg')" alt="">
                                </router-link>
                      </div>
                    </div>

                  </div>


                  <div class="" v-if="project.challenges.scouting_challenge">
                    <div class="action_list done" v-if="sf.scouting_challenge.isSubmit">
                      <div class="name">
                        <router-link :to="'/scouting_space/'+sf._id.$oid+'/'+project._id.$oid">
                          <span>{{$t('Scouting brief')}}</span>
                                  <img :src="require('@/assets/action_go_to.svg')" alt="">
                        </router-link>
                      </div>
                    </div>

                  </div>

                  <div class="" v-if="project.challenges.assessment_challenge">
                              <div class="action_list" :class="(sf.assessments) ? 'done' : ''"  v-if="sf.candidatesPools.length || sf.assessments">
                                <div class="name">
                                  <router-link :to="'/my_pools/'+sf._id.$oid+'/'+project._id.$oid+'?noLongList=true'">
                                    <span>{{$t("Selected innovators")}}</span>
                                           <img :src="require('@/assets/action_go_to.svg')" alt="">
                                         </router-link>
                                </div>

                              </div>

                              <div class="action_list" :class="(sf.assessments) ? 'done' : ''" v-if="(sf.assessments)" >
                                                    <div class="name" >
                                                      <router-link :to="'/manage_assessments?project='+project._id.$oid">
                                                        <span>{{$t('Assessment results')}}</span>
                                                              <img :src="require('@/assets/action_go_to.svg')" alt="">
                                                            </router-link>
                                                    </div>

                              </div>

                            </div>
                   </div>
                 </div>
               </div>

             </div>

           </div>
            <!-- <div class="project_searchfields" v-for="(sf, s) in projet.search_field" :key="s">
                <div class="searchfield_name">
                  <router-link :to="'/projet/'+projet._id.$oid+'#'+sf._id.$oid">{{sf.name}}</router-link>
                </div>
                <div class="searchfield_action_required">
                  <div class="action_list" v-for="(task, t) in sf.tasks" :key="t" style="margin-top:5px;margin-bottom:5px;">

                    <router-link :to="'/business_challenge_space/'+projet._id.$oid" v-if="task.status != 'not-available' && task.task_code == 'business_challenge'">{{task.task_name}}   <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge></router-link>
                    <router-link :to="'/scouting_space/'+sf._id.$oid+'/'+projet._id.$oid" v-else-if="task.status != 'not-available' && task.task_code == 'scouting_brief'">{{task.task_name}}   <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge></router-link>

                    <router-link :to="'/my_pools/'+sf._id.$oid+'/'+projet._id.$oid" v-else-if="task.status != 'not-available' && task.task_code == 'assessment_definition'">Qualify candidates  <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge></router-link>
                    <router-link :to="'/assessment/'+sf._id.$oid+'/'+projet._id.$oid" v-else-if="task.status != 'not-available' && task.task_code == 'assessment'">View assessed candidates   <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge></router-link>
                    <router-link :to="'/summary/'+projet._id.$oid" v-else-if="task.status != 'not-available'">select partners  <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge></router-link>

                    <span v-else>
                      <span v-if="task.task_code == 'assessment_definition'">QUALIFY CANDIDATES</span>
                      <span v-else-if="task.task_code == 'assessment'">VIEW ASSESSED CANDIDATES</span>
                      <span v-else-if="task.task_code == 'ended'">SELECT PARTNERS</span>
                      <span v-else-if="task.task_code == 'candidate_selection'">SELECT PARTNERS</span>
                      <span v-else>{{task.task_name}} </span>
                   <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge></span>
                  </div>

                </div>
                <div class="searchfield_deliverable">
                    <div v-for="(task, t) in sf.innopearl_tasks" :key="t"  class="action_list" style="margin-top:5px;margin-bottom:5px;">


                      <router-link :to="'/business_challenge_space/'+projet._id.$oid" v-if="task.status == 'done' && task.task_code == 'business_challenge'">
                        {{task.task_name}}
                        <v-badge v-if="task.isNew" color="#008000" content="NEW" inline></v-badge>
                      </router-link>
                      <router-link :to="'/scouting_space/'+sf._id.$oid+'/'+projet._id.$oid" v-else-if="task.status == 'done' && task.task_code == 'scouting_brief'">
                        {{task.task_name}}
                        <v-badge v-if="task.isNew" color="#008000" content="NEW" inline></v-badge>
                      </router-link>
                      <router-link :to="'/candidatespool/'+sf._id.$oid+'/'+projet._id.$oid" v-else-if="task.status == 'done' && task.task_code == 'assessment_definition'">
                        {{task.task_name}}
                        <v-badge v-if="task.isNew" color="#008000" content="NEW" inline></v-badge>
                      </router-link>
                      <router-link :to="'/assessment/'+sf._id.$oid+'/'+projet._id.$oid" v-else-if="task.status == 'done' && task.task_code == 'assessment'">
                        {{task.task_name}}
                        <v-badge v-if="task.isNew" color="#008000" content="NEW" inline></v-badge>
                      </router-link>
                      <span v-else>{{task.task_name}}   <v-badge v-if="task.status == 'required'" color="#6C68A2" content="IN PROGRESS" inline></v-badge></span>

                    </div>
                </div>
            </div> -->





    </div>
  </div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
// import { Toaster, toast } from 'vue-sonner'

import api from '../tools/api';
import { toast } from 'vue-sonner'


export default {
  components: {
    AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      pageInfo: {
        mainTitle : "My dashboard space",
        subTitle : "All my projects",
      },
      projects: [
        {
          id: "1",
          name: "Projet 1",
          search_fields : [
            {
              name: "SF1",
              id: "1",
              next_user_action: {
                name: "action utilisateur",
                status: "required",
              },
              next_innopearl_action: {
                name : "Element available",
                status: "new",
              }
            },
            {
              name: "SF2",
              id: "2",
              next_user_action: null,
              next_innopearl_action: {
                name : "Element available",
                status: "in progress",
              }
            }
          ]

        },
        {
          id: "2",
          name: "Projet 2",
          search_fields : [
            {
              name: "SF1",
              id: "2",
              next_user_action: {
                name: "action utilisateur",
                status: "required",
              },
              next_innopearl_action: {
                name : "Element available",
                status: "new",
              }
            },
            {
              name: "SF2",
              id: "2",
              next_user_action: null,
              next_innopearl_action: {
                name : "Element available",
                status: "in progress",
              }
            },
            {
              name: "SF3",
              id: "2",
              next_user_action: {
                name: "action utilisateur",
                status: "required",
              },
              next_innopearl_action: null,
            }
          ]

        }

      ], //have to be get from DB
      actions_required_qty : 0, //have to be set by iterate on projects
      new_deliverable_qty : 0, //have to be set by iterate on projects
    }
  },
  methods:{

  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

    api.get(process.env.VUE_APP_API_URL+"/restrict/project_dashboard_full_V2").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r);
            if(r.data){
              this.projects = r.data;

            }
          else{
            this.projects = [];
          }
    }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
  },
}
</script>
<style scoped>
.all_my_projects_space{
  /* padding-top:50px; */
  /* padding-bottom: 50px; */
}
.all_my_projects_content{
  padding: 50px;
  background: #FFF;
}

.top_info{
  padding-bottom: 50px;
border-bottom: 1px solid #ADB3B5;
}
.actions_required{
  font-size :19px;
  line-height: 23px;
  letter-spacing: 0px;
  color: #C63221;
}
.new_deliverable{
  font-size :19px;
  line-height: 23px;
  letter-spacing: 0px;
  color: #008000;
}
.actions_required .number,
.new_deliverable .number{
  font-size: 32px;
  line-height: 39px;
}

.projectList .project{
  margin-top: 50px;
  margin-bottom: 50px;
}
.projectList .projectName{
  font-size : 28px;
  line-height: 34px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
text-decoration: none;
}
.projectList .project_searchfields{
  display:flex;
  flex-wrap: wrap;
  width: 100%;

  padding-top:50px;
  padding-bottom: 50px;
  border-bottom: 1px solid #CCC;
}

@media screen and (max-width: 990px){
  .projectList .project_searchfields{
    flex-direction: column;
    gap: 20px;
}
}
.projectList .project_searchfields div{
  flex: 1;
}
.projectList .project_searchfields .searchfield_name{
  font-size:18px;
  line-height: 28px;
letter-spacing: 0px;
color: #b38d2f;
text-transform: uppercase;
}
.projectList .project_searchfields .searchfield_name a{
text-decoration: none;
letter-spacing: 0px;
color: #b38d2f;
text-transform: uppercase;
}
.projectList .project_searchfields .searchfield_deliverable,
.projectList .project_searchfields .searchfield_action_required{
  font-size :13px;
  line-height:16px ;
letter-spacing: 0px;
color: #575757;
text-transform: uppercase;
padding-left:20px;
padding-right:20px;
}

.mt30{
  margin-top: 30px;
  }
  .mb30{
    margin-bottom:30px;
  }
  .action_title{
    letter-spacing: 0px;
  color: #3783C5;
  text-transform: none;
  font-size:18px;
  line-height: 21px;
  margin-top:0px;
  margin-bottom: 20px;
  display: block;
  font-weight: 600;
  }
   .action_list{
     display: flex;
     gap: 20px;
     margin-top:25px;
     font-size:15px;
     line-height:20px;
     text-transform: uppercase;
     background:#3783C51A;
     border-radius:200px;
     padding-left:25px;
     padding-right:25px;
     padding-top:15px;
     padding-bottom: 14px;
     justify-content: space-between;
     color:#3783C5 !important;
     font-weight: 500;
     opacity: .5;
   }
   .action_list.done{
     opacity:1;
   }

   .action_list .name{
     width:100%;
   }
   .action_list .name a{
     display: flex;
     justify-content: space-between;
     width: 100%;
        color:#3783C5 !important;
   }
   .action_list .name a img{
        transition: transform 330ms ease-in-out;
   }
   .action_list .name a:hover img{
   transform:translateX(5px);
   }
</style>
